export default "__VITE_ASSET__pCLkM6xe__"